/* TODO: Refactor */
import { navigate } from "@reach/router";
import { graphql, Link } from "gatsby";
import React, { Component } from "react";
import { GatsbyImage, StaticImage } from "gatsby-plugin-image";
import { Scrollchor } from "react-scrollchor";
import AppLink from "../../components/appLink/AppLink";
import Grid, { Col } from "../../components/grid/Grid";
import Meta from "../../components/meta/Meta";
import Video from "../../components/video/Video";
import Section from "../../components/section/Section";
import capitalise from "../../utils/capitalise";
import { kebabCase } from "../../utils/kebabCase";
import PageLabel from "../../components/pageLabel/PageLabel";
import * as styles from "./index.module.css";

const renderJobItem = job => (
  <li key={job.id} className={styles.jobItem}>
    <AppLink to={`https://boards.greenhouse.io/ustwo/jobs/${job.gh_Id}`} external largeExternal>
      <div className={styles.jobItemName}>{job.title}</div>
      <div className="smallBodyText fontWeightNormal">
        {job.offices && job.offices[0].name}
      </div>
    </AppLink>
  </li>
);

const renderDepartmentSections = depts => {
  const list = depts.map((dept) => {
    const jobs = dept.jobs;

    return (
      <div key={dept.id} className={styles.deptJobList}>
        <h2 className="h4 noTopMargin">{dept.name}</h2>
        <ul>{jobs.map((job) => renderJobItem(job, dept.name))}</ul>
      </div>
    );
  });

  return list;
};

class JoinUs extends Component {
  constructor(props) {
    super(props);

    const studio = props.location.hash.slice(1, props.location.hash.length);

    this.state = {
      activeDept: "all",
      activeStudio: kebabCase(studio) || "all",
    };

    this.handleStudioFilterChange = this.handleStudioFilterChange.bind(this);
  }

  handleDeptFilterClick(dept) {
    return () => {
      this.setState({
        activeDept: dept,
      });
    };
  }

  handleStudioFilterChange(event) {
    const hash = `#${event.target.value}`;
    navigate(hash);
    this.setState({
      activeStudio: event.target.value,
      activeDept: "all",
    });
  }

  renderSidebar(deptData) {
    const { activeDept, activeStudio } = this.state;

    let totalJobs = 0;
    // eslint-disable-next-line
    deptData.forEach((dept) => (totalJobs += dept.jobs.length));

    const renderDeptFilterItems = deptData
      // Sort alphabetically
      .sort((a, b) => {
        const nameA = a.name.toUpperCase();
        const nameB = b.name.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      })
      .map((dept) => (
        <li key={dept.id} className="smallBodyText">
          <button
            onClick={this.handleDeptFilterClick(dept.name)}
            className={`smallerBodyText ${dept.name === activeDept ? styles.selectedDept : ""}`}
          >
            {`${dept.name} (${dept.jobs.length})`}
          </button>
        </li>
      ));

    const studios = ["London", "Malmo", "New York", "Lisbon", "Tokyo"];

    const renderStudioFilterItems = studios.map((studio) => {
      const kebabStudio = kebabCase(studio);
      return (
        <option value={kebabStudio} key={kebabStudio}>
          {studio}
        </option>
      );
    });

    return (
      <div>
        <label htmlFor="studio-filter" className={styles.filterTitle} aria-hidden="true">Filter by Studio</label>
        <select
          id="studio-filter"
          value={activeStudio}
          onBlur={this.handleStudioFilterChange}
          onChange={this.handleStudioFilterChange}
          className={styles.studioFilter}
        >
          <option value="all">All Locations</option>
          {renderStudioFilterItems}
        </select>
        <ul className={styles.jobFilterList}>
          <li className="smallerBodyText">
            <button
              onClick={this.handleDeptFilterClick("all")}
              className={`smallerBodyText ${activeDept === "all" ? styles.selectedDept : ""}`}
            >
              {`All Categories (${totalJobs})`}
            </button>
          </li>
          {renderDeptFilterItems}
        </ul>
        <ul className={`${styles.helpfulLinks} textMarginTopLarge`}>
          <li><h4 className="smallBodyText">Helpful links</h4></li>
          <li className="smallerBodyText"><Scrollchor to="#hiring-guide" animate={{ duration: 600 }}>Hiring guide</Scrollchor></li>
          <li className="smallerBodyText"><Link to="/employee-owned/">Employee Owned</Link></li>
          <li className="smallerBodyText"><a href="https://www.linkedin.com/company/ustwo-">LinkedIn</a></li>
          <li className="smallerBodyText"><a href="http://www.twitter.com/ustwo">Twitter/X</a></li>
        </ul>
      </div>
    );
  }

  componentDidMount() {
    const { activeStudio } = this.state;
    this.setState({ activeStudio });
  }

  render() {
    const { data } = this.props;
    const { activeDept, activeStudio } = this.state;

    // Sanitise
    const deptData = data.allGreenhouseDepartment.edges.map((x) => x.node);

    // TODO: Make this better!
    const studioFiltered = deptData
      .filter((dept) => dept.jobs !== null)

      // .filter((dept) => dept.name.indexOf("Games") === -1)
      // .filter((dept) => dept.jobs.length > 0)
      .map((dept) => {
        const filtered = dept.jobs
          // .filter(job => job.external) // Filter out all internal jobs
          .filter(
            (job) =>
              activeStudio === "all" ||
              job.location.name.includes(capitalise(activeStudio))
          )
        
        // .filter(job => job.offices[0].name != "Games")
          // .filter((job) =>
          //   activeStudio === "all" ||
          //   job.location.name.includes(capitalise(activeStudio))
        return {
          ...dept,
          jobs: filtered,
        };
      })
      // Filter out depts with no jobs
      .filter((y) => y.jobs.length > 0);

    const deptAndStudioFiltered = studioFiltered
      // Show list of jobs from filtered dept
      .filter((dept) => activeDept === "all" || activeDept === dept.name);

    return (
      <article className={styles.jobs}>
        <Section header>
          <PageLabel>{data.content.frontmatter.title}</PageLabel>
          <Grid>
            <Col span={7} start={1}>
              <h1 className="noMargin">{data.content.frontmatter.tagline}</h1>
            </Col>
          </Grid>
        </Section>

        <GatsbyImage image={data.content.hero && data.content.hero.childImageSharp.gatsbyImageData} alt={data.content.frontmatter.heroAlt} />

        <Section padding="both">
          <Grid>
            <Col span={5} start={1}>
              <div>
                <h2 className="">Experience the freedom and autonomy to make decisions that you think are best</h2>
              </div>
            </Col>
            <Col start={7} span={4}>
              <p className="textMarginBottomLarge">
                You will work with some of the most talented and smartest people of your career, who show deep care for others. We don’t take ourselves too seriously though - it’s all about enjoying the journey.
              </p>
              <Scrollchor to="#open-roles" animate={{ duration: 1000 }} className="">
                <div className="button buttonFill">Our Open Roles</div>
              </Scrollchor>
            </Col>
          </Grid>
        </Section>

        <Section padding="both" backgroundColor="offWhite">
          <h2 className="noMargin">Benefits</h2>
          <Grid className={styles.benefits}>
            <Col start={1} span={3}>
              <p className={styles.benefitsIntro}>As a B Corp we put people and the planet before profit. This extends into our benefits.</p>
            </Col>
            <Col span={4} start={5}>
              <ul>
                <li>Healthcare coverage</li>
                <li>Retirement savings</li>
                <li>Profit share</li>
                <li>Wellness & resilience benefits</li>
                <li>Inclusivity training</li>
                <li>People manager training</li>
              </ul>
            </Col>
            <Col span={4} start={9}>
              <ul>
                <li>Referral bonuses</li>
                <li>Annual growth & development</li>
                <li>Work from anywhere policy</li>
                <li>10 weeks & 10K at 10 years</li>
                <li>5 days vacation at 5 years</li>
                <li>3 month sabbatical at 3 years</li>
              </ul>
            </Col>
          </Grid>
          <Grid>
            <Col span={6} start={5}>
              <p className={`smallestBodyText ${styles.benefitsNote} textMarginTop`}>Our benefits are specific to the rules and regulations of each local studio. For example, we offer a commuter bonus for Malmö employees travelling from Copenhagen.</p>
            </Col>
          </Grid>
        </Section>

        <Section
          padding="both"
          backgroundColor="offBlack"
          lightOnDark
        >
        <Grid className="textMarginBottomLarge">
          <Col start={1} span={4}>
            <h2 className="noMargin">Meet Our Teams</h2>
          </Col>
        </Grid>
        <Grid>
          <Col start={1} span={4}>
            <p>Our projects are usually made up of a cross-discipline team of Design, Tech, Strategy, Product and Delivery depending on our client’s requirements.</p>
          </Col>
        </Grid>
        <Grid padding="both" columns={3}>
          <div>
            <StaticImage className="mediumTile" src="https://assets.ustwo.com/images/studio/team-rachael-collaboration-table.jpg" alt="" />
            <h3 className="h4">Design</h3>
            <p className="smallerBodyText">Designing for the full product life cycle, from visioning and discovery, validating propositions to launching products and services that are valuable to both users and businesses.</p>
          </div>
          <div>
            <StaticImage className="mediumTile" src="https://assets.ustwo.com/images/studio/new-york-team-workshop.jpg" alt="" />
            <h3 className="h4">Strategy</h3>
            <p className="smallerBodyText">Lead, motivate and support project and client teams, developing client relationships, articulating a vision, and instilling confidence with pragmatic recommendations.</p>
          </div>
          <div>
            <StaticImage className="mediumTile" src="https://assets.ustwo.com/images/studio/nyc-collaboration.jpg" alt="" />
            <h3 className="h4">Product</h3>
            <p className="smallerBodyText">Shipping commercially viable products that have market fit, meeting key business objectives and ensuring the optimal value of delivery in the time available.</p>
          </div>
          <div className="textMarginTopLarge">
            <StaticImage className="mediumTile" src="https://assets.ustwo.com/images/studio/ustwo-studio-tech.jpg" alt="" />
            <h3 className="h4">Tech</h3>
            <p className="smallerBodyText">Building beautiful and intuitive products while solving problems across the full web stack - frontend web, backend and infrastructure development.</p>
          </div>
          <div className="textMarginTopLarge">
            <StaticImage className="mediumTile" src="https://assets.ustwo.com/images/studio/two-ustwobies.jpg" alt="" />
            <h3 className="h4">Delivery</h3>
            <p className="smallerBodyText">Supporting teams using agile principles, creating an atmosphere of collaboration, overcoming conflicts, managing logistics, budgets, risks and stakeholders’ expectations.</p>
          </div>
          <div className="textMarginTopLarge">
            <StaticImage className="mediumTile" src="https://assets.ustwo.com/images/studio/london-operations-team.jpg" alt="" />
            <h3 className="h4">Operations</h3>
            <p className="smallerBodyText">Marketing, finance, people, studio management, IT and resource functions who work in the background keeping the business running smoothly.</p>
          </div>
        </Grid>
      </Section>

        <Section padding="both">
          <Grid>
            <Col span={4} start={1}>
              <h2>Everyone who works at ustwo studios is a partner.</h2>
              <p className="textMarginBottomLarge">
                <span className="">This means we can preserve our independence and invest in our people.</span>
              </p>
              <p className="textMarginBottomSmall">
                <Link to="/employee-owned" className="button">Employee owned</Link>
              </p>
            </Col>
            <Col start={5} span={8}>
              <Grid columns={3}>
                <div>
                  <Video
                    lowerPlayButton
                    src="https://assets.ustwo.com/video/voxPop-julie.mp4"
                    staticPoster={<StaticImage src="https://assets.ustwo.com/video/voxPop-julie-placeholder.jpg" />}
                  />
                </div>
                <div>
                  <Video
                    lowerPlayButton
                    src="https://assets.ustwo.com/video/voxPop-ana.mp4"
                    staticPoster={<StaticImage src="https://assets.ustwo.com/video/voxPop-ana-placeholder.jpg" />}
                  />
                </div>
                <div>
                  <Video
                    lowerPlayButton
                    src="https://assets.ustwo.com/video/voxPop-marit.mp4"
                    staticPoster={<StaticImage src="https://assets.ustwo.com/video/voxPop-marit-placeholder.jpg" />}
                  />
                </div>
              </Grid>
            </Col>
          </Grid>
        </Section>

        <Section padding="both" backgroundColor="offWhite">
          <Grid>
            <Col start={1} span={5}>
              <h3 className="noTopMargin">We work hybridly</h3>
              <p>We embrace a progressive approach to work that combines the best of both worlds. With the understanding that flexibility and adaptability are key to success in today's fast-paced world, we have created an environment where individuals can seamlessly transition between working remotely and collaborating in our studios.</p>
              <p>With five beautiful studios globally, we provide the space for ustwobies to meet, collaborate and build strong working relationships.</p>
            </Col>
            <Col span={5} start={7}>
              <h3 className="noTopMargin">We want to nurture and grow our industry</h3>
              <p>We are passionate about driving innovation and fostering knowledge-sharing within the tech industry. From conferences and workshops to hackathons and networking sessions, our events provide valuable opportunities for learning, collaboration, and networking.</p>
              <p>We believe that by bringing the tech community together, we can inspire creativity, facilitate meaningful connections, and contribute to the growth and development of the industry as a whole.</p>
            </Col>
          </Grid>
        </Section>

        <Section id="open-roles" padding="both">
          <Grid padding="bottom">
            <h2 className="noMargin">Open roles</h2>
          </Grid>
          <Grid>
            <Col start={1} span={3}>
              {this.renderSidebar(studioFiltered)}
            </Col>
            <Col start={5} span={8}>
              {renderDepartmentSections(deptAndStudioFiltered)}
              <div>
                <h2 className="h4">{deptAndStudioFiltered.length === 0 ? "Currently no open roles" : "Nothing to your fancy?"}</h2>
                <p>ustwo is always on the lookout for exceptional talent and our needs are always changing. If you don't see a position that fits your expertise, check back in the future or follow us on social media to get the latest news updates! All our jobs get posted to linkedin via our job board so keeping an eye on our linkedin page would be a great place to start.</p>
                <p>
                  Please see our{" "}
                  <Link to="/recruitment-privacy-notice">
                    Recruitment Privacy Notice
                  </Link>
                  .
                </p>
              </div>
            </Col>
          </Grid>
        </Section>

        <Section padding="both" backgroundColor="offWhite" id="hiring-guide">
          <Grid padding="bottom">
            <Col start={1} span={5}>
              <h2 className="noMargin">Our Interview Process</h2>
            </Col>
          </Grid>
          <Grid className="smallerBodyText">
            <Col start={1} span={7}>
              <h3 className="h4 noTopMargin">General advice</h3>
              <p>Interviewing for a new role can be intimidating so we want to make sure we are making it as comfortable as possible for you to show your best self.</p>
              <ul>
                <li>
                  Most of our interviews are held on google hangouts (particularly for the initial stages) so we would recommend becoming familiar with the software if you haven’t used it before. If you are interviewing for a role where you would like to share your screen to show us something then practising sharing your screen (and making sure your permissions are set to do so) is a huge time saver!
                </li>
                <li>
                  Designers, we will always ask you to present some of your portfolio. More often than not we will want to see work where you have been involved in the end to end process and we’re happy for you to show us case studies or figma files so we really understand how you work as a designer.
                </li>
                <li>
                  Do your research on ustwo and who you’ll be meeting (we’ll give you names ahead of time). We love hearing about what you learnt about us so we can discuss it fully at the interview stage.

                </li>
                <li>Our standard interviews are usually booked for 1 hour (unless stated otherwise).</li>
                <li>
                  Be concise. It’s helpful to practice how you would answer the basic interview questions so you don’t go off on a tangent and if the interviewer wants more details they will dig into particular parts of your answer. Remember we want to hear about what you specifically did on a team.
                </li>
                <li>
                  When working at ustwo you will more often than not work with a cross-discipline team. We’re super keen to hear about how you’ve done that in the past and any challenges you have found. We don’t mind hearing about when things went wrong, after all we’re all human!
                  </li>
                <li>
                  Come with questions, this is your chance to interview us too! We’re happy to be quizzed and will always give you an opportunity to ask us questions at the end of each interview.
                </li>
              </ul>
              <p>We’re super excited to welcome you onsite, if you have any questions before your interview please don’t hesitate to <Link to="/contact-us/">let us know</Link>.</p>
            </Col>
            <Col start={9} span={4}>
              <h3 className="h4 noTopMargin">FAQs</h3>
              <h4>Where to go?</h4>
              <p>Check out our <Link to="/contact-us/">locations</Link> for full addresses of our studios. If you have any difficulty finding us please do reach out to your ustwo contact who will be happy to assist you.</p>
              <h4>What to wear?</h4>
              <p>We are very casual, so feel free to wear whatever makes you comfortable.</p>
              {/* <h4>What to expect?</h4>
              <p>Overview of our values and definition of Fampany</p>
              <ul>
                <li>The role,</li>
                <li>The brief,</li>
                <li>The team you will be meeting,</li>
                <li>What we will assess.</li>
              </ul> */}
            </Col>
          </Grid>
        </Section>
      </article>
    );
  }
}

export default JoinUs;

export const Head = ({ data }) => {
  const { seoTitle, description } = data.content.frontmatter;
  return <Meta title={seoTitle} description={description} imgsrc={data.content.thumbnail && data.content.thumbnail.publicURL} />;
}

export const query = graphql`
  query {
    content: mdx(frontmatter: {name: { eq: "joinus" } }) {
      ...PageDefault
    }
    allGreenhouseDepartment {
      edges {
        node {
          id
          name
          jobs {
            id
            gh_Id
            title
            location {
              name
            }
            offices {
              name
            }
          }
        }
      }
    }
  }
`;
